import React from 'react'
import Helmet from 'react-helmet'

export default props => (
  <Helmet {...props}>
    <html lang="en" />
  </Helmet>
)
